import { Autocomplete, TextField, useTheme } from '@mui/material'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { ETranslationNs, IQuantityTypeBaseWithId } from 'src/types'

import useStyles from 'src/components/text-input/styles'
import { useStyles as useStyles2 } from './styles'
import { useQuantityTypes } from 'src/hooks/quantity-types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  disabled?: boolean
}

const QuantityTypeInput = ({ disabled }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { data: quantityTypes, isLoading } = useQuantityTypes()
  const { values, handleChange, errors } = useFormikContext<{ quantity_type: string }>()
  const theme = useTheme()
  const classes = useStyles({ disabled })
  const classes2 = useStyles2()

  const handleQuantityTypeChange = (event: any, value: string | null | IQuantityTypeBaseWithId) => {
    handleChange({
      target: {
        name: 'quantity_type',
        value,
      },
    })
  }

  const placeholder = `${t('text-input-placeholder-prepend.v', { ns: ETranslationNs.Form })} ${t(
    'quantity-type-input-placeholder.v',
  )}`
  return (
    <Autocomplete
      disablePortal
      autoHighlight
      options={quantityTypes?.data || []}
      disabled={disabled}
      value={values.quantity_type ? values.quantity_type : disabled ? placeholder : ''}
      ListboxProps={{ className: classes2.inputList }}
      isOptionEqualToValue={(option, value) =>
        typeof value === 'string' ? option.name === value : option.id === value.id
      }
      freeSolo
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
      fullWidth
      onChange={handleQuantityTypeChange}
      groupBy={(prop) => prop.category?.name || 'Other'}
      loading={isLoading}
      loadingText={t('loading-text-notification.v')}
      renderInput={(props) => (
        <TextField
          {...props}
          autoComplete="off"
          variant="standard"
          className={classes.container}
          InputProps={{
            ...props.InputProps,
            disableUnderline: true,
          }}
          inputProps={{
            ...props.inputProps,
            className: classes.input,
          }}
          InputLabelProps={{
            className: classes.label,
            style: {
              color: theme.palette.custom.grey2,
            },
            focused: true,
          }}
          FormHelperTextProps={{ style: { marginTop: -2 } }}
          focused
          size="small"
          label={
            <HelperWrapper
              t="quantity-type-input-label"
              ns={ETranslationNs.Form}
              isColorInherited
              usePortal
            />
          }
          id={'quantity_type'}
          name={'quantity_type'}
          placeholder={placeholder}
          onChange={handleChange}
          type={'text'}
          error={!!errors.quantity_type}
          helperText={errors.quantity_type && <HelperWrapper t={errors.quantity_type} />}
        />
      )}
    />
  )
}

export { QuantityTypeInput }
